<script>
import CustomCommonConfig from './CustomCommonConfig';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  extends: CustomCommonConfig,
  mixins: [validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      //useStatistics: true,
      useThresholdRange: true, // 위험구간 설정 화면 display 여부
      configTitle: this.$t('title.timeSeriesGraph'), // 위젯 config 타이틀
      defaultConfig: this.config({
        // 위젯 설정정보
        isResizable: true,
        maxW: 8,
        maxH: 6,
        minH: 2,
        h: 2,
        widget: {
          type: 'TimeSeriesGraphWidget',
          api: '/cloudmonitorings/product/v1/console/metric-data',
          options: { chartType: 'line' }
        }
      }),
      validateFieldKey: 'timeSeriesGraphWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    updateFieldsBeforeModify() {
      this.setFieldsBeforeModify();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles/customCommonConfig.scss';

.area.monitoring-target {
  display: block;
}
</style>
